import { CSSProperties } from "react"
import Colors from "../../../../../../../constants/Colors"
import FontWeight from "../../../../../../../constants/FontWeight"

export default class DialogHeaderViewStyle {

    header: CSSProperties = {
        height: 85,
        backgroundColor: Colors.Primary,
        display: "flex"
    }

    headerTextContainer: CSSProperties = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        flex: 1,
        paddingLeft: 30,
        paddingTop: 15,
        paddingRight: 15,
        paddingBottom: 15
    }

    title: CSSProperties = {
        color: '#fff',
        fontFamily: "Roboto",
        fontWeight: FontWeight.LIGHT,
        marginBottom: 0,
        fontSize: 15
    }

    subtitle: CSSProperties = {
        color: "#fff",
        fontFamily: "Asap",
        fontWeight: FontWeight.MEDIUM,
        fontSize: 22
    }

    smallLogo: CSSProperties = {
        height: 50,
        paddingLeft: 20,
        paddingRight: 20,
        alignSelf: "flex-end"
    }
}